import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "neon-tile neon-rounded p-2" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "media" }
const _hoisted_4 = { class: "me-2" }
const _hoisted_5 = { class: "media-body" }
const _hoisted_6 = { class: "d-flex mt-2 justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_avatar = _resolveComponent("vue-avatar")!
  const _component_vue_markdown = _resolveComponent("vue-markdown")!
  const _component_vue_button = _resolveComponent("vue-button")!
  const _directive_profile = _resolveDirective("profile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives((_openBlock(), _createElementBlock("a", null, [
            _createVNode(_component_vue_avatar, {
              name: _ctx.user.name,
              photo: _ctx.user.photo,
              initials: _ctx.user.initials,
              id: _ctx.user.id,
              "is-online": _ctx.user.is_online,
              class: "img-thumbnail media-object i-38"
            }, null, 8 /* PROPS */, ["name", "photo", "initials", "id", "is-online"])
          ])), [
            [_directive_profile, _ctx.user.id]
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_vue_markdown, {
            modelValue: $data.defaultText,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.defaultText) = $event)),
            emojis: $data.emojis,
            onSave: $options.saveComment,
            ref: "markdown",
            "preview-url": "/Mikroblogi/Preview"
          }, null, 8 /* PROPS */, ["modelValue", "emojis", "onSave"]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_vue_button, {
              disabled: $data.isSubmitting,
              onClick: $options.saveComment,
              class: "btn btn-primary btn-sm",
              tabindex: "3",
              title: "Ctrl+Enter aby opublikować"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode(" Zapisz ")
              ])),
              _: 1 /* STABLE */,
              __: [1]
            }, 8 /* PROPS */, ["disabled", "onClick"])
          ])
        ])
      ])
    ])
  ]))
}